import { IHallBooking } from "src/domain/entities"
import { hallBookingAddApi } from "../../api/hallBooking/hallBookingAddApi"

type PayloadShape = Parameters<typeof hallBookingAddApi>[0]

export async function hallBookingAddService(
	payload: PayloadShape,
	token?: null | string,
) {
	const hallBooking = await hallBookingAddApi(payload, token)
	return hallBooking as NonNullable<IHallBooking>
}
